// packages block
import React, { useState } from "react";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@material-ui/core";
// common block
import "../../style.css";
import { FormButton } from "../../../form/button";
// constants, theme, utils and api block
import smsIcon from "../../../../assets/images/sms-icon.png";
import emailIcon from "../../../../assets/images/email-icon.png";
import { BLUE_EIGHT, ORANGE_TWO, WHITE } from "../../../../theme";
import watsappIcon from "../../../../assets/images/watsapp-icon.png";
import appNotifyIcon from "../../../../assets/images/app-notify-icon.png";
import { styled } from "@material-ui/core/styles";

const CheckboxWithIcon = ({ checked, handleChange, icon, label }) => {
  const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: 100,
    width: 12,
    height: 12,
    outline: "1px solid #707070",
  }));

  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: "#006E7D",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      content: '""',
    },
  });
  return (
    <div style={{ marginBottom: 30 }}>
      <Checkbox
        style={{ marginRight: 25 }}
        checked={checked}
        onChange={handleChange}
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
      />
      <img
        src={icon}
        alt={label}
        style={{ width: 25, marginRight: 10 }} // added margin to separate from label
      />
      <label
        style={{
          fontSize: "0.85vw",
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 700,
          lineHeight: 1.5,
        }}
      >
        {label}
      </label>
    </div>
  );
};

const NotifyParentDialogContent = ({
  handleClose,
  loading,
  handleContinue,
}) => {
  const [sendPushNotification, setSendPushNotification] = useState(true);
  const [sendWatsapp, setSendWatsapp] = useState(true);
  const [sendEmail, setSendEmail] = useState(true);
  const [sendSMS, setSendSMS] = useState(true);
  return (
    <div>
      <Typography variant="h5" className="notify_dialog_description">
        This will send a notification to all the selected student's parent on
        their registered mobile number and registered email address to quickly
        pay the Fee via PayNest mobile App.
      </Typography>

      <Typography variant="h5" className="notify_dialog_heading">
        Please select notification method to continue ?
      </Typography>

      <div style={{ marginLeft: 20 }}>
        <CheckboxWithIcon
          checked={sendPushNotification}
          handleChange={() => setSendPushNotification(!sendPushNotification)}
          icon={appNotifyIcon}
          label="In app push notification"
        />
        <CheckboxWithIcon
          checked={sendEmail}
          handleChange={() => setSendEmail(!sendEmail)}
          icon={emailIcon}
          label="Email Notification"
        />
        <CheckboxWithIcon
          checked={sendSMS}
          handleChange={() => setSendSMS(!sendSMS)}
          icon={smsIcon}
          label="SMS notification"
        />
        <CheckboxWithIcon
          checked={sendWatsapp}
          handleChange={() => setSendWatsapp(!sendWatsapp)}
          icon={watsappIcon}
          label="Whatsapp notification"
        />
      </div>

      <div className="notify_dialog_buttons">
        <FormButton
          title={"Cancel"}
          backgroundColor={WHITE}
          borderColor={ORANGE_TWO}
          titleColor={ORANGE_TWO}
          hoverBackgroundColor={ORANGE_TWO}
          hoverBorderColor={WHITE}
          hoverTitleColor={WHITE}
          onClickHandler={handleClose}
          height={40}
          width={"10vw"}
          borderTopRightRadius={15}
          borderTopLeftRadius={15}
          borderBottomLeftRadius={15}
          borderBottomRightRadius={15}
          style={{
            fontSize: "0.8vw",
            fontWeight: "700",
            textTransform: "capitalize",
          }}
        />

        <span className="notify_dialog_continue_button">
          {sendEmail === true ||
          sendPushNotification === true ||
          sendSMS === true ||
          sendWatsapp === true ? (
            <FormButton
              title={"Continue"}
              onClickHandler={() => {
                handleContinue(
                  sendPushNotification,
                  sendEmail,
                  sendSMS,
                  sendWatsapp
                );
              }}
              height={40}
              width={"10vw"}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
              loading={loading}
              backgroundColor={WHITE}
              titleColor={BLUE_EIGHT}
              hoverTitleColor={WHITE}
              hoverBackgroundColor={BLUE_EIGHT}
              style={{
                fontSize: "0.8vw",
                fontWeight: "700",
                textTransform: "capitalize",
                paddingLeft: 20,
                paddingRight: 20,
              }}
              hoverBorderColor={BLUE_EIGHT}
            />
          ) : (
            <FormButton
              title={"Check First"}
              onClickHandler={() => {
                handleContinue(
                  sendPushNotification,
                  sendEmail,
                  sendSMS,
                  sendWatsapp
                );
              }}
              height={40}
              width={"13vw"}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
              loading={loading}
              overRideButtonCheck={true}
              disabled={true}
              style={{
                fontSize: "0.8vw",
                fontWeight: "700",
                textTransform: "capitalize",
                paddingLeft: 20,
                paddingRight: 20,
              }}
              backgroundColor={BLUE_EIGHT}
              titleColor={WHITE}
            />
          )}
        </span>
      </div>
    </div>
  );
};

export default NotifyParentDialogContent;
